export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Activate.vue?vue&type=template&id=f223999a&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/components/user-activation/Activate.vue?vue&type=template&id=f223999a&scoped=true&
// module id = 941
// module chunks = 0